export class SongModel{
    constructor(public title: string, public description: string, public imgUrl: string, public publish: string, public src: string, public catID: string, public _id: string){}
}